export default (value) => {
  const result = parseFloat(value, 10)
  return !isNaN(result) ? result.toFixed(1) : '0'
}



// WEBPACK FOOTER //
// ./src/filters/tofixedone.js